import { notification } from "../../../../../../utils/notification";
import { SectorProperties, TextToInsert } from "../../constants/interface";
import { setSectorSelected, updateSectorData } from "./helper";
import { EditorModes, SelectedKeys } from "../../constants/types";
import React from "react";

export const handleSchemaActionClick = (
  e: React.MouseEvent<SVGSVGElement>,
  data: any,
  editMode: boolean,
  undoStack: any[],
  setUndoStack: React.Dispatch<React.SetStateAction<any[]>>,
  setData: React.Dispatch<React.SetStateAction<any>>,
  setSelectedKeys: React.Dispatch<React.SetStateAction<SelectedKeys>>,
  setText: React.Dispatch<React.SetStateAction<any>>,
  editorModes: EditorModes,
  textToInsert: TextToInsert,
  setTextToInsert: React.Dispatch<React.SetStateAction<TextToInsert>>
) => {
  if (!data || !editMode) return;
  if (
    editorModes.deleteCircle.enabled ||
    (!editorModes.dotInsert && !editorModes.textInsert)
  )
    return;

  const svgElement = e.target as SVGSVGElement;
  const svgRect = svgElement.getBoundingClientRect();
  const svgCTM = svgElement.getScreenCTM();
  if (!svgCTM) return;

  const mouseX = e.clientX - svgRect.left;
  const mouseY = e.clientY - svgRect.top;
  const adjustedX = mouseX / svgCTM.a;
  const adjustedY = mouseY / svgCTM.d;
  const fineTuneX = adjustedX - 20;
  const fineTuneY = adjustedY + 1;

  if (editorModes.textInsert.enabled) {
    textToInsert.rect!.x = fineTuneX.toString();
    textToInsert.rect!.y = fineTuneY.toString();
    textToInsert.styles.transformOrigin =
      fineTuneX.toString() + "px " + fineTuneY.toString() + "px";

    if (
      !textToInsert ||
      Object.keys(textToInsert).length === 0 ||
      textToInsert.properties!.text === ""
    ) {
      return;
    }

    setUndoStack([...undoStack, data]);
    setData((prevData: { properties: { text: any } }) => ({
      ...prevData,
      properties: {
        ...prevData.properties,
        text: [...(prevData.properties?.text || []), textToInsert],
      },
    }));
    setText((prevText: any) =>
      Array.isArray(prevText) ? [...prevText, textToInsert] : [textToInsert]
    );
    setTextToInsert(() => ({
      properties: {
        text: "",
        type: "text",
      },
      rect: { x: "", y: "" },
      styles: {},
    }));
    setSelectedKeys((prevState) => ({
      ...prevState,
      selectedKeyText: "",
    }));

    return;
  }
};

export const HandleOnSeatClick = (
  id: any,
  key: string,
  editMode: boolean,
  editorModes: EditorModes,
  data: any,
  setData: React.Dispatch<React.SetStateAction<any>>,
  addRowsColsToSector: SectorProperties,
  selectionSectorType: string,
  setSectorProperties: React.Dispatch<React.SetStateAction<SectorProperties>>,
  setSelectedKey: React.Dispatch<React.SetStateAction<string>>,
  setSelectedDots: React.Dispatch<React.SetStateAction<Record<string, any>>>,
  undoStack: any[],
  setUndoStack: React.Dispatch<React.SetStateAction<any[]>>,
  deSelectAll: () => void
) => {
  if (!data || !key || !editMode) {
    return;
  }

  if (editorModes.insertSeatInRowOrCol.enabled) {
    setSelectedKey(key);

    return;
  }

  if (editorModes.selectItem.enabled) {
    setSectorProperties({ readonly: true });
    setSelectedKey(key);
    setSectorSelected(
      key,
      selectionSectorType,
      setSelectedDots,
      data,
      setData,
      deSelectAll
    );

    return;
  } else {
    const newData = JSON.parse(JSON.stringify(data));
    if (!newData.data) {
      return;
    }

    if (editorModes.dotInsert.enabled) {
      setSectorProperties({ readonly: false });
      if (addRowsColsToSector) {
        updateSectorData(
          addRowsColsToSector,
          newData,
          key,
          setData,
          setSelectedKey
        );
      }

      return;
    }

    if (editorModes.deleteCircle.enabled) {
      if (newData.data && newData.data[key]) {
        setUndoStack([...undoStack, data]);

        delete newData.data[key];
        setData(newData);
      } else {
        notification({
          type: "error",
          title: `Seat with key ${key} not found`,
        });
        console.error(`Seat with key ${key} not found`);
      }

      return;
    }
  }
};
